import SectionHeading from '../../ui/SectionHeading/SectionHeading.jsx';
import Card from '../../ui/Card/Card.jsx';
import { testimonials } from '../../../data/testimonials.js';
import styles from './Testimonials.module.css';

export default function Testimonials() {
  return (
    <section className={styles.section}>
      <div className="container">
        <SectionHeading
          eyebrow="Product teams, in their own words"
          title="Launched with Solvora"
          align="center"
        />
        <div className={styles.grid}>
          {testimonials.map((t) => (
            <Card key={t.name} className={styles.card}>
              <p className={styles.quote}>"{t.quote}"</p>
              <div className={styles.person}>
                <span className={styles.avatar} aria-hidden="true">{t.name.charAt(0)}</span>
                <div>
                  <span className={styles.name}>{t.name}</span>
                  <span className={styles.role}>{t.role}</span>
                </div>
              </div>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
}
